<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" size="mini" label-width="85px">
        <div class="formItemBox">
        <el-form-item label="盘库单号:">
          <el-input type="text" v-model="formData.inventoryNo" size="mini"
            placeholder="请输入盘库单号"></el-input>
        </el-form-item>
        <el-form-item label="订单状态:">
          <el-select v-model="formData.orderStatus" size="mini" placeholder="请选择订单状态" filterable clearable>
            <el-option v-for="item in orderStatusData" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库客户:">
          <el-select v-model="formData.customerName" size="mini" placeholder="请选择盘库客户" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.custerName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人:">
          <el-input v-model="formData.createUser "  size="mini"
            placeholder="请输入创建人"></el-input>
        </el-form-item>
        <el-form-item label="创建时间:">
          <div style="display: flex;">
          <el-date-picker v-model="formData.createTimeStart" size="mini" type="datetime" placeholder="请选择创建时间"
            value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
          -
          <el-date-picker v-model="formData.createTimeEnd" size="mini" placeholder="请选择创建时间" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="仓位:">
          <el-select v-model="formData.warehouseName" size="mini" placeholder="请选择">
            <el-option v-for="item in addKuwei" :label="item.warehouseName" :key="item.warehouseId" :value="item.warehouseName"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" btnCode="003P01wB001" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="003P01wB002" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="zuofei" btnCode="003P01wB003" v-if="btnFlg[2]">作废</el-button>
          <el-button type="primary" size="mini" @click="shanchu" btnCode="003P01wB004" v-if="btnFlg[3]">删除</el-button>
          <el-button type="primary" size="mini" @click="panhuo" btnCode="003P01wB005" v-if="btnFlg[4]">盘货完成</el-button>
          <el-button type="primary" size="mini" @click="exportClick" btnCode="003P01wB006" v-if="btnFlg[5]">导出
          </el-button>
          <el-button type="primary" size="mini" @click="addJB(btnFlg[6])" v-if="btnFlg[6]">新建卷板</el-button>
          <el-button type="primary" size="mini" @click="addJC(btnFlg[7])" v-if="btnFlg[7]">新建建材</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
        style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row @row-click="dianjixuanzhong" @selection-change="selectGoods">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column fixed width="150" label="操作" align="center">
          <template v-slot='scope'>
            <el-button type="text" @click="HWclick(scope.$index,scope.row)">货物</el-button>
            <el-button type="text" @click="RYclick(scope.$index,scope.row)">人员</el-button>
            <el-button type="text" v-if="scope.row.chargeOrNot=='是'&&scope.row.orderStatus=='已结束'"
              @click="FYclick(scope.$index,scope.row)">费用</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="orderStatus" label="订单状态" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryNo" label="盘库单号" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="盘库客户" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓库" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryType" label="盘库类型" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allnumber" label="总件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量" width="120" align="center">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="totalFee" label="费用总计" align="center"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="orderSource" label="订单来源" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="180" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeStart" label="盘库开始时间" width="180"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeEnd" label="盘库结束时间" width="180"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="chargeOrNot" label="是否收费" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="付款状态" width="120" align="center">
          <template slot-scope="scope">
            <span style="color:red" v-if="scope.row.payStatus=='0'">未收款</span>
            <span v-else-if="scope.row.payStatus=='1'">已收款</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payType" label="付款方式" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payPerson" label="付款人" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payTime" label="付款时间" width="180" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <el-dialog title="盘库完成" v-if="pankuFinish" :visible.sync="pankuFinish" width="35%" center
      :before-close="closepanku">
      <el-form style="width:50%;margin:0 auto;" :model="pankuFinishForm" class="demo-form-inline" ref="formData">
        <el-form-item label="订单来源:">
          <div>{{pankuFinishForm.orderSource}}</div>
        </el-form-item>
        <el-form-item label="盘库客户:">
          <div>{{pankuFinishForm.customerName}}</div>
        </el-form-item>
        <el-form-item label="是否收费:">
          <el-radio-group v-model="pankuFinishForm.radio">
            <el-radio :label="'是'">是</el-radio>
            <el-radio :label="'否'">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="FinishOk">确定</el-button>
        <el-button type="primary" @click="closepanku">取消</el-button>
      </div>
    </el-dialog>
    <billsDetail v-if="zhangdanDetailVisible" :zhangdanDetailVisible.sync="zhangdanDetailVisible"
      :inventoryMasterId="inventoryMasterId"></billsDetail>
  </div>
</template>

<script>
import billsDetail from '@/views/wms-stock/cangChu/jiesuan/billsDetail.vue'

import {
  getRelationCustomer,
  getInventoryOrderList,
  deleteNoInventoryOrder,
  deleteInventoryOrder,
  finishInventoryList,
  zidianKuwei
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'
export default {
  components: {
    billsDetail
  },

  data () {
    return {
      formData: {
        inventoryNo: '',
        orderStatus: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        createUser: ''
      },
      RKData: [],
      orderStatusData: [{
        id: 0,
        name: '待盘库'
      },
      {
        id: 1,
        name: '盘库中'
      },
      {
        id: 2,
        name: '已结束'
      },
      {
        id: 3,
        name: '已作废'
      }
      ],
      h: '500px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      btnArr: [
        '003P01wB001',
        '003P01wB002',
        '003P01wB003',
        '003P01wB004',
        '003P01wB005',
        '003P01wB006',
        '003P010100',
        '003P010200',
        '003P010400',
        '003P010500'
      ],
      btnFlg: [],
      xuanzhongArr: null,
      selectList: [],

      zhangdanDetailVisible: false,
      inventoryMasterId: '',
      pankuFinish: false,
      pankuFinishForm: {
        customerName: '',
        orderSource: '',
        radio: '是'
      },
      addKuwei: []
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
    this.getRelationCustomerS()
    this.zidianKuweiS()
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/inventoryOrder')
    this.chaxun()
  },
  methods: {
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    closepanku () {
      this.pankuFinish = false
    },
    FinishOk () {
      this.$confirm('是否确定盘货完成？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(res => {
        console.log(res)
        finishInventoryList({
          inventoryMasterId: this.selectList[0].inventoryMasterId,
          chargeOrNot: this.pankuFinishForm.radio
        }).then(res => {
          console.log(res)
          this.$message.success('盘货完成')
          this.pankuFinish = false
          this.chaxun()
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    getInventoryOrderList () {
      getInventoryOrderList({
        ...this.formData,
        ...this.pageInfo,
        inventoryID: -1
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.getInventoryOrderList()
    },
    chongzhi () {
      this.formData = {}
      this.chaxun()
    },
    zuofei () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要作废的数据')
      } else if (this.selectList.length > 1) {
        this.$message.error('请选择一条数据操作')
      } else {
        this.$confirm('是否确定作废？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(res => {
          console.log(res)
          deleteNoInventoryOrder({
            inventoryMasterId: this.selectList[0].inventoryMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('作废成功')
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    shanchu () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要删除的数据')
      } else {
        let ids = []
        this.selectList.forEach(item => {
          ids.push(item.inventoryMasterId)
        })
        ids = ids.join(',')
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(res => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          console.log(res)
          deleteInventoryOrder({
            inventoryMasterIds: ids
          }).then(res => {
            loading.close()
            this.$message.success('删除成功')
            this.chaxun()
          })
            .catch(error => {
              loading.close()
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    panhuo () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要盘货的数据')
      } else if (this.selectList.length > 1) {
        this.$message.error('请选择一条数据操作')
      } else {
        this.pankuFinishForm.orderSource = this.selectList[0].orderSource
        this.pankuFinishForm.customerName = this.selectList[0].customerName
        this.pankuFinish = true
      }
    },
    // 选中
    selectGoods (selection) {
      this.selectList = selection
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      this.formData.inventoryID = -1
      exportExcel(
        this.global.wmsStockName + '/inventory/exportInventoryOrderList',
        this.formData,

        '盘库订单信息表'
      )
    },
    // 提价panku
    tijiao () {},
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    HWclick (index, row) {
      if (row.inventoryType == '建材') {
        this.$router.push({
          name: 'cargoJC',
          query: {
            inventoryMasterId: row.inventoryMasterId,
            btnFlg: this.btnFlg
          }
        })
      } else {
        this.$router.push({
          name: 'Cargo',
          query: {
            inventoryMasterId: row.inventoryMasterId,
            btnFlg: this.btnFlg
          }
        })
      }
    },
    RYclick (index, row) {
      this.$router.push({
        name: 'People',
        query: {
          inventoryMasterId: row.inventoryMasterId
        }
      })
    },
    FYclick (index, row) {
      this.zhangdanDetailVisible = true
      this.inventoryMasterId = String(row.inventoryMasterId)
    },
    addJB (btnId) {
      this.$router.push({
        name: 'addJB',
        query: {
          menuOrBtnId: btnId
        }
      })
    },
    addJC (btnId) {
      this.$router.push({
        name: 'addJC',
        query: {
          menuOrBtnId: btnId
        }
      })
    }
  }

}

</script>

<style lang='less' scoped>
  .messages {
    font-size: 16px;
  }

  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
